import { Transition } from "@headlessui/react";
import { ToolbarSection } from "./Toolbar";

export default function ColorLimitBar({ show, colorLimit, setColorLimit, editor, setShowColorLimitBar }) {
    return (
        <Transition.Root
            show={show}
            style={{
                left: "calc(50% - 205px)",
                bottom: 160,
            }}
            className="absolute z-100"
        >
            <Transition.Child
                className=""
                enter="transition-all ease-in-out duration-200"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-all ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <ToolbarSection className="p-4 bg-black backdrop-blur-sm bg-opacity-70 flex flex-col rounded-xl relative sm:flex-row">
                    <button
                        onClick={() => setShowColorLimitBar(false)}
                        className="absolute top-2 right-2 text-white hover:text-gray-300 focus:outline-none"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    <label
                        htmlFor="default-range"
                        className="mx-4 block mb-4 text-sm font-medium text-white"
                    >
                        Reduce colors
                    </label>
                    <input
                        onBlur={() => setShowColorLimitBar(false)}
                        onChange={(e) => {
                            setColorLimit(e.target.value);
                            editor?.quantizeColors(
                                e.target.value / 10.0
                            );
                        }}
                        id="default-range"
                        type="range"
                        step={1}
                        defaultValue={colorLimit}
                        min={0}
                        max={10}
                        className="mx-8 w-full bg-gray-200 rounded-lg appearance-none cursor-pointer"
                    />
                </ToolbarSection>
            </Transition.Child>
        </Transition.Root>
    );
}